export const likeFunctions = {
  POST: 'PostLike',
};
